import { render } from "./sidebar-layout.vue?vue&type=template&id=2d957d6e&scoped=true"
import script from "./sidebar-layout.vue?vue&type=script&lang=js"
export * from "./sidebar-layout.vue?vue&type=script&lang=js"

import "./sidebar-layout.vue?vue&type=style&index=0&id=2d957d6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d957d6e"]])

export default __exports__